import {
  MultiSelectProps,
  MultiSelect as MantineMultiSelect,
  ComboboxItem,
  ComboboxItemGroup,
} from "@mantine/core"
import { forwardRef } from "react"

import { useSortSelectOptions } from "../Select/useSortSelectOptions"

import classes from "./MultiSelect.module.css"

type Props = MultiSelectProps & {
  emptyMessage?: string
  sort?:
    | ((
        a: string | ComboboxItem | ComboboxItemGroup,
        b: string | ComboboxItem | ComboboxItemGroup
      ) => number)
    | false
}

export const MultiSelect = forwardRef<HTMLInputElement, Props>(
  ({ sort, emptyMessage, data, placeholder, error, ...props }, ref) => {
    const sortData = useSortSelectOptions({ sort })
    const sortedData =
      data && data.length > 0
        ? sortData(data)
        : emptyMessage
          ? [
              {
                label: emptyMessage,
                value: "",
              },
            ]
          : []
    return (
      <MantineMultiSelect
        {...props}
        classNames={classes}
        ref={ref}
        data={sortedData}
        placeholder={props.value?.length === 0 ? placeholder : undefined}
        aria-sort={sort ? "ascending" : "none"}
        error={error}
      />
    )
  }
)
MultiSelect.displayName = "MultiSelect"
